import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';

const ContactFormFragment = ({ fragmentId, fragmentUrl }) => {
	const formFragmentRef = useRef(null);

	useEffect(() => {
		// loading animation
		$(formFragmentRef.current).not('.ajax-load-complete')
			.before(`<span class="loading-ajax-container loading">
						<i class="ddc-icon ddc-icon-specs-gear1 ddc-icon-size-xlarge"></i> Loading...
					 </span>`);

		// form fragment
		$(formFragmentRef.current)
			.removeClass('hide')
			.load(encodeURI(fragmentUrl), () => {
				$(formFragmentRef.current)
					.css('visibility', 'visible')
					.siblings('.loading')
					.remove()
					.find('.ddc-content');
			});
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<div
			className="hide ajax-form-element"
			data-fragment-id={fragmentId}
			data-fragment-url={fragmentUrl}
			ref={formFragmentRef}
		/>
	);
};

export default ContactFormFragment;

ContactFormFragment.propTypes = {
	fragmentId: PropTypes.string.isRequired,
	fragmentUrl: PropTypes.string.isRequired
};
